














import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { MerchFoodForBusinessDto } from "../../../types/interface/Food/foodTypes";

@Component
export default class SlotModal extends Vue {
  @Prop({ type: String, default: `Modify the number of dishes` })
  title!: string;
  @Prop(Boolean) value!: boolean;
  @Prop({ type: Number, default: 450 }) width!: number;

  public get show(): boolean {
    return this.value;
  }

  public set show(v: boolean) {
    this.$emit("input", v);
  }
}
